// @flow

import React from 'react';
import {renderers} from '@stripe-internal/markdoc';
import Box from 'sail/Box';
import * as components from 'docs/components';
import {useAccount} from 'docs/data';
import type {Article} from 'docs/data';
import classnames from 'classnames';

type MarkdocContentProps = {|
  article: Article,
|};

export const VideoPlaylistContent = ({article}: MarkdocContentProps) => {
  const {account} = useAccount();

  const className = classnames(
    'Content-article',
    'MarkdocContentWrapper',
    'Content-VideoPlaylist',
  );

  return (
    <Box
      className={className}
      style={{
        width: '100%',
        maxWidth: '1750px',
        margin: '0 auto',
      }}
    >
      <article id="content" data-locale={account.locale.code}>
        <Box padding={{horizontal: 64, bottom: 24}}>
          {renderers.react(article.content, React, {components})}
        </Box>
      </article>
    </Box>
  );
};
